/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import {
  CMSSpacer,
  type CMSSpacerProps,
} from '@/features/contentstack/components/CMSSpacer/CMSSpacer';
import React from 'react';

const CMSPLPSpacer = ({ children, ...props }: CMSSpacerProps) => {
  return (
    <CMSSpacer shelfPage {...props}>
      {children}
    </CMSSpacer>
  );
};

export { CMSPLPSpacer };
